import React from "react";
import PropTypes from "prop-types";
import { Add as AddIcon } from "@material-ui/icons";
import { Box, Grid } from "@material-ui/core";
import CashPaymentTable from "./CashPaymentTable";
import translate from "../../../../i18n/translate";
import { SrButton, SrContentHeader, SrContentWrapper } from "../../../common";

const GetBallots = ({
  onCreate,
  transactions,
  paginationConfig,
  loading,
  toastSuccess,
}) => (
  <>
    <Grid container direction="column" spacing={2}>
      <SrContentHeader
        title={
          transactions?.rows?.length
            ? translate("menu.sentBallots")
            : translate("menu.cashPayment")
        }
        actions={
          <SrButton
            startIcon={<AddIcon />}
            color="primary"
            variant="contained"
            onClick={onCreate}
          >
            {translate("common.createBallot")}
          </SrButton>
        }
      />

      <SrContentWrapper
        isEmpty={!transactions?.rows?.length}
        isLoading={loading}
        emptyMessage={translate("common.noData")}
      >
        <Box
          marginTop="40px"
          width="100%"
          justifyContent="center"
          display="flex"
        >
          <CashPaymentTable
            transactions={transactions}
            paginationConfig={paginationConfig}
            loading={loading}
            toastSuccess={toastSuccess}
          />
        </Box>
      </SrContentWrapper>
    </Grid>
  </>
);

GetBallots.propTypes = {
  onCreate: PropTypes.func.isRequired,
};

export default GetBallots;
